module.exports = __webpack_public_path__ + "img/bedland_slide_2.2e902d67.jpg";